/**
 * PAPPO — Invitations Service
 * Convites de recrutamento orgânico (/api/invitations).
 */

import { apiGet, apiPost } from './api';

export interface InvitationInfo {
  inviter_name: string;
  inviter_role: string;
  is_child_invite: boolean;
  state: 'pending' | 'accepted' | 'expired';
}

/** Gera um convite para o utilizador atual */
export async function createInvite() {
  return apiPost<{ token: string }>('/invitations');
}

/** Info pública do convite (não exige login) */
export async function getInvite(token: string) {
  return apiGet<{ invitation: InvitationInfo }>(`/invitations/${token}`);
}

/** Adulto livre aceita o convite (conexão automática) */
export async function acceptInvite(token: string) {
  return apiPost<{ inviter_name: string; conversation_id?: number }>(
    `/invitations/${token}/accept`
  );
}

/** Responsável aceita o convite em nome de um filho */
export async function acceptForChild(token: string, childId: number) {
  return apiPost<{ pending_inviter_approval: boolean }>(
    `/invitations/${token}/accept-for-child`,
    { child_id: childId }
  );
}
